import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonSkeletonText
} from '@ionic/react';

import styles from './InviteTeammatesCard.module.scss';

import { State } from '../../constants/state';
import { Service } from '../../services/service';
import { ServiceLoader } from '../../stories/ServiceLoader/ServiceLoader';
import { TeammatesLoading } from '../../stories/TeammatesLoading/TeammatesLoading';
import { Organization, Repository, Teammate } from '../../types/services.types';
import { TeammateList } from '../TeammateList/TeammateList';

interface InviteTeammatesCardProps {
  loading: boolean;
  onInviteClicked: (email: string) => Promise<void>;
  organization?: Organization;
  repository?: Repository;
  service: Service;
  teammates?: Teammate[];
  token?: string;
}

export default function InviteTeammatesCard({
  loading,
  service,
  organization,
  repository,
  teammates,
  token,
  onInviteClicked
}: InviteTeammatesCardProps) {
  if (loading) {
    return (
      <section className={styles.cardContainer}>
        <ServiceLoader service={service.id} state={State.Loading} />
        <IonCard className={styles.card}>
          <IonCardHeader>
            <IonCardTitle>
              <IonSkeletonText
                animated
                style={{ width: '200px' }}
              ></IonSkeletonText>
            </IonCardTitle>
            <IonCardSubtitle>
              <IonSkeletonText
                animated
                style={{ width: '400px' }}
              ></IonSkeletonText>
            </IonCardSubtitle>
          </IonCardHeader>

          <IonCardContent>
            <TeammatesLoading />
          </IonCardContent>
        </IonCard>
      </section>
    );
  } else if (organization && teammates) {
    return (
      <section className={styles.cardContainer}>
        <ServiceLoader service={service.id} state={State.Successful} />
        <IonCard className={styles.card}>
          <IonCardHeader>
            <IonCardTitle>Invite your teammates</IonCardTitle>
            <IonCardSubtitle>
              Extend your existing plan by inviting your team!
            </IonCardSubtitle>

            <a href="https://git.live/premium" target="_blank" rel="noreferrer">
              Learn more about our pricing plans →
            </a>
          </IonCardHeader>

          <IonCardContent>
            <TeammateList
              photoUrl={organization.photoURL}
              name={repository?.displayName ?? organization.displayName}
              teammates={teammates}
              token={token}
              service={service}
              onInviteClicked={onInviteClicked}
            />
          </IonCardContent>
        </IonCard>
      </section>
    );
  }
}
